export class CSharpLanguage
{
  public static readonly token ="c#";

  public static readonly keywords:string[] = 
  [
    "var","new","void","short","long","uint",
    "float","int","byte","bool","double","string",
    "List", "Dictionary", "HashSet",
    "using","static","async","partial","await","namespace"
  ]
  
  
}